import "./App.css";
import { BrowserRouter as Router } from "react-router-dom";
import { Routing } from "./routes/routes";
import { ErrorBoundary } from "./Screens/Common/ErrorBoundary";
import { useEffect } from "react";

function App() {
  // The app is up: public/index.html stops watching for a build that failed
  // to load (and may try once more after the next deploy).
  useEffect(() => {
    window.__appStarted?.();
  }, []);

  return (
    <ErrorBoundary fullPage>
      <Router>
        <Routing />
      </Router>
    </ErrorBoundary>
  );
}

export default App;
